export default __webpack_public_path__ + "static/media/7-arrival_in_hong_kong.f83b8d04.jpg";